(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avorasafe-home-services"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    var DRAFT_KEY = 'avorasafe-hs-draft-v1';
    var DRAFT_VERSION = 1;
    var DRAFT_MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 heures — voir correction du 2026-08-18

    function clearDraft() {
      try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {}
    }

    ready(function () {
      var section = document.querySelector('.avorasafe-hs');
      if (!section) return;

      var successBox = section.querySelector('[data-avorasafe-success]');
      if (successBox) {
        clearDraft();
        window.setTimeout(function () {
          successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          successBox.focus();
        }, 50);
      }

      var form = section.querySelector('.avorasafe-hs-form');
      if (!form) return;

      form.setAttribute('novalidate', 'novalidate');

      var summary = section.querySelector('[data-avorasafe-summary]');
      var errorBox = section.querySelector('.avorasafe-hs-form__error');

      var i18n = {};
      var i18nEl = form.querySelector('[data-avorasafe-i18n]');
      if (i18nEl) {
        try { i18n = JSON.parse(i18nEl.textContent); } catch (e) { i18n = {}; }
      }

      // --- Conservation des données saisies (survit à un rechargement ou à
      // une redirection Shopify inattendue — voir correction du 2026-08-18).
      // Brouillon horodaté, versionné et expirant après 2 heures : ne reste
      // jamais indéfiniment sur un ordinateur partagé. ---
      function collectDraft() {
        var draft = { v: DRAFT_VERSION, savedAt: Date.now() };
        var nameEl = document.getElementById('AS-name');
        var phoneEl = document.getElementById('AS-phone');
        var emailEl = document.getElementById('AS-email');
        var cityEl = document.getElementById('AS-city');
        var dateEl = document.getElementById('AS-date');
        var bodyEl = document.getElementById('AS-body');
        var consentEl = document.getElementById('AS-consent');
        if (nameEl) draft.name = nameEl.value;
        if (phoneEl) draft.phone = phoneEl.value;
        if (emailEl) draft.email = emailEl.value;
        if (cityEl) draft.city = cityEl.value;
        if (dateEl) draft.date = dateEl.value;
        if (bodyEl) draft.body = bodyEl.value;
        if (consentEl) draft.consent = consentEl.checked;
        var demandeur = form.querySelector('input[name="contact[La demande est pour]"]:checked');
        draft.demandePour = demandeur ? demandeur.value : '';
        var besoin = form.querySelector('input[name="contact[Besoin]"]:checked');
        draft.besoin = besoin ? besoin.value : '';
        var moment = form.querySelector('input[name="contact[Moment préféré]"]:checked');
        draft.moment = moment ? moment.value : '';
        var serviceGroupEl = form.querySelector('[data-avorasafe-group="avorasafe-service-checkboxes"]');
        draft.services = serviceGroupEl
          ? Array.prototype.filter
              .call(serviceGroupEl.querySelectorAll('.checkbox__input'), function (c) { return c.checked; })
              .map(function (c) { return c.value; })
          : [];
        return draft;
      }

      function saveDraft() {
        try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(collectDraft())); } catch (e) {}
      }

      function checkRadioByValue(name, value) {
        if (!value) return;
        var radios = form.querySelectorAll('input[name="' + name + '"]');
        Array.prototype.forEach.call(radios, function (r) { if (r.value === value) r.checked = true; });
      }

      function restoreDraft() {
        var raw;
        try { raw = sessionStorage.getItem(DRAFT_KEY); } catch (e) { return; }
        if (!raw) return;

        var draft;
        try { draft = JSON.parse(raw); } catch (e) { clearDraft(); return; }

        if (!draft || typeof draft !== 'object' || draft.v !== DRAFT_VERSION || typeof draft.savedAt !== 'number') {
          // Format inconnu, corrompu, ou provenant d’une version antérieure
          // du formulaire : on ne restaure jamais un brouillon incompatible.
          clearDraft();
          return;
        }

        if (Date.now() - draft.savedAt > DRAFT_MAX_AGE_MS) {
          // Brouillon expiré (plus de 2 heures) : supprimé intégralement,
          // rien n’est restauré.
          clearDraft();
          return;
        }

        var nameEl = document.getElementById('AS-name');
        var phoneEl = document.getElementById('AS-phone');
        var emailEl = document.getElementById('AS-email');
        var cityEl = document.getElementById('AS-city');
        var dateEl = document.getElementById('AS-date');
        var bodyEl = document.getElementById('AS-body');
        var consentEl = document.getElementById('AS-consent');

        if (draft.name && nameEl && !nameEl.value) nameEl.value = draft.name;
        if (draft.phone && phoneEl && !phoneEl.value) phoneEl.value = draft.phone;
        if (draft.email && emailEl && !emailEl.value) emailEl.value = draft.email;
        if (draft.city && cityEl && !cityEl.value) cityEl.value = draft.city;
        if (draft.date && dateEl && !dateEl.value) dateEl.value = draft.date;
        if (draft.body && bodyEl && !bodyEl.value) bodyEl.value = draft.body;
        if (draft.consent && consentEl && !consentEl.checked) consentEl.checked = true;
        checkRadioByValue('contact[La demande est pour]', draft.demandePour);
        checkRadioByValue('contact[Besoin]', draft.besoin);
        checkRadioByValue('contact[Moment préféré]', draft.moment);

        if (draft.services && draft.services.length) {
          var serviceGroupEl = form.querySelector('[data-avorasafe-group="avorasafe-service-checkboxes"]');
          if (serviceGroupEl) {
            Array.prototype.forEach.call(serviceGroupEl.querySelectorAll('.checkbox__input'), function (c) {
              if (draft.services.indexOf(c.value) !== -1) c.checked = true;
            });
          }
        }

        syncServiceCheckboxes();
      }

      function syncServiceCheckboxes() {
        var group = form.querySelector('[data-avorasafe-group="avorasafe-service-checkboxes"]');
        var hidden = document.getElementById('AS-service-combined');
        var proxy = document.getElementById('AS-service-required-proxy');
        if (!group || !hidden) return;
        var checked = Array.prototype.filter.call(group.querySelectorAll('.checkbox__input'), function (c) {
          return c.checked;
        });
        hidden.value = checked
          .map(function (c) { return c.value; })
          .join(', ');
        if (proxy) proxy.checked = checked.length > 0;
      }

      var serviceGroup = form.querySelector('[data-avorasafe-group="avorasafe-service-checkboxes"]');
      if (serviceGroup) {
        serviceGroup.addEventListener('change', syncServiceCheckboxes);
      }

      // Restaure les valeurs précédemment saisies (rechargement, retour après
      // une redirection Shopify) avant tout autre traitement du formulaire.
      restoreDraft();

      form.addEventListener('input', saveDraft);
      form.addEventListener('change', saveDraft);

      function fieldWrapper(el) {
        return el.closest('.avorasafe-hs-form__field');
      }

      function showFieldError(el, message) {
        var wrapper = fieldWrapper(el);
        if (!wrapper) return;
        wrapper.classList.add('avorasafe-hs-form__field--invalid');
        var errorEl = wrapper.querySelector('.avorasafe-hs-form__field-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'avorasafe-hs-form__field-error';
          wrapper.appendChild(errorEl);
        }
        errorEl.textContent = message;
        if (!errorEl.id) {
          errorEl.id = (el.id || wrapper.dataset.avorasafeGroup || 'as-field').replace(/[^a-zA-Z0-9-]/g, '') + '-error';
        }
        if (el.tagName === 'FIELDSET') {
          el.setAttribute('aria-invalid', 'true');
        } else {
          el.setAttribute('aria-invalid', 'true');
          el.setAttribute('aria-describedby', errorEl.id);
        }
      }

      function clearFieldError(el) {
        var wrapper = fieldWrapper(el);
        if (!wrapper) return;
        wrapper.classList.remove('avorasafe-hs-form__field--invalid');
        var errorEl = wrapper.querySelector('.avorasafe-hs-form__field-error');
        if (errorEl) errorEl.remove();
        el.removeAttribute('aria-invalid');
        el.removeAttribute('aria-describedby');
      }

      var checks = [
        {
          message: i18n.name,
          getTarget: function () { return form.querySelector('#AS-name'); },
          isValid: function (el) { return el.value.trim() !== ''; }
        },
        {
          message: i18n.phone,
          getTarget: function () { return form.querySelector('#AS-phone'); },
          isValid: function (el) { return el.value.trim() !== ''; }
        },
        {
          message: i18n.email,
          getTarget: function () { return form.querySelector('#AS-email'); },
          isValid: function (el) { return el.value.trim() !== '' && el.checkValidity(); }
        },
        {
          message: i18n.demandePour,
          getTarget: function () { return form.querySelector('[data-avorasafe-group="contact[La demande est pour]"]'); },
          isValid: function () {
            return Array.prototype.some.call(form.querySelectorAll('input[name="contact[La demande est pour]"]'), function (r) { return r.checked; });
          }
        },
        {
          message: i18n.city,
          getTarget: function () { return form.querySelector('#AS-city'); },
          isValid: function (el) { return el.value.trim() !== ''; }
        },
        {
          message: i18n.service,
          getTarget: function () { return form.querySelector('[data-avorasafe-group="avorasafe-service-checkboxes"]'); },
          isValid: function (group) {
            return Array.prototype.some.call(group.querySelectorAll('.checkbox__input'), function (c) { return c.checked; });
          }
        },
        {
          message: i18n.need,
          getTarget: function () { return form.querySelector('[data-avorasafe-group="contact[Besoin]"]'); },
          isValid: function () {
            return Array.prototype.some.call(form.querySelectorAll('input[name="contact[Besoin]"]'), function (r) { return r.checked; });
          }
        },
        {
          message: i18n.moment,
          getTarget: function () { return form.querySelector('[data-avorasafe-group="contact[Moment préféré]"]'); },
          isValid: function () {
            return Array.prototype.some.call(form.querySelectorAll('input[name="contact[Moment préféré]"]'), function (r) { return r.checked; });
          }
        },
        {
          message: i18n.consent,
          getTarget: function () { return form.querySelector('#AS-consent'); },
          isValid: function (el) { return el.checked; }
        }
      ];

      // --- Défilement + focus contrôlés (parcours guidé, correction du
      // 2026-08-18) : un seul déplacement propre, jamais deux scrolls qui se
      // disputent. Respecte prefers-reduced-motion et évite le double-scroll
      // natif du navigateur en utilisant focus({ preventScroll: true }).
      function prefersReducedMotion() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      }

      function focusableWithin(target) {
        if (!target) return null;
        return target.tagName === 'FIELDSET' ? target.querySelector('input') : target;
      }

      function scrollAndFocus(target) {
        if (!target) return;
        var reduceMotion = prefersReducedMotion();
        var focusEl = focusableWithin(target);
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(
          function () {
            if (focusEl) focusEl.focus({ preventScroll: true });
          },
          reduceMotion ? 0 : 350
        );
      }

      function validate() {
        var firstInvalidTarget = null;
        var anyInvalid = false;

        checks.forEach(function (check) {
          var target = check.getTarget();
          if (!target) return;
          if (check.isValid(target)) {
            clearFieldError(target);
          } else {
            showFieldError(target, check.message);
            anyInvalid = true;
            if (!firstInvalidTarget) firstInvalidTarget = target;
          }
        });

        return { anyInvalid: anyInvalid, firstInvalidTarget: firstInvalidTarget };
      }

      var submitButton = form.querySelector('.avorasafe-hs-form__submit');
      var guidedModeActive = false;

      function getOrderedInvalidChecks() {
        return checks.filter(function (check) {
          var target = check.getTarget();
          return target && !check.isValid(target);
        });
      }

      function advanceGuidedMode() {
        var remaining = getOrderedInvalidChecks();
        if (!remaining.length) {
          guidedModeActive = false;
          if (summary) summary.hidden = true;
          if (submitButton) scrollAndFocus(submitButton);
          return;
        }
        scrollAndFocus(remaining[0].getTarget());
      }

      function onFieldCommitted(check) {
        if (!guidedModeActive) return;
        var target = check.getTarget();
        if (!target) return;
        if (check.isValid(target)) {
          clearFieldError(target);
          advanceGuidedMode();
        }
      }

      // Si la page affiche déjà une erreur (retour d'une soumission réellement
      // envoyée à Shopify), on signale localement tout ce qui manque encore et on
      // active le parcours guidé, comme après une tentative de soumission bloquée.
      if (errorBox) {
        var initialResult = validate();
        if (initialResult.anyInvalid) guidedModeActive = true;
      }

      var isSubmitting = false;

      form.addEventListener('submit', function (e) {
        // Toujours annuler l'action native EN PREMIER, avant toute validation :
        // la navigation est bloquée dès le tout début de la tentative, sans
        // dépendre du résultat de validate(). C'est le seul point d'entrée vers
        // Shopify pour ce formulaire ; voir plus bas pour le seul chemin
        // explicite qui la réautorise (formulaire entièrement valide).
        e.preventDefault();

        if (isSubmitting) return;

        syncServiceCheckboxes();
        saveDraft();
        var result = validate();

        if (result.anyInvalid) {
          guidedModeActive = true;
          if (summary) summary.hidden = false;
          scrollAndFocus(result.firstInvalidTarget);
          return;
        }

        guidedModeActive = false;
        if (summary) summary.hidden = true;
        isSubmitting = true;
        // form.submit() (plutôt que requestSubmit()) contourne volontairement
        // les écouteurs 'submit' — dont celui-ci — pour soumettre une seule
        // fois, sans reboucler dans cette validation. Jamais atteint tant
        // qu'un seul champ obligatoire est invalide.
        form.submit();
      });

      // --- Progression automatique du parcours guidé : un déclencheur adapté à
      // chaque type de champ ("commit"), jamais pendant la frappe. blur pour le
      // texte/téléphone/courriel ; change pour les listes, groupes de radios,
      // cases à cocher de services et la case de consentement. ---
      function wireCommit(el, eventName, checkIndex) {
        if (!el) return;
        el.addEventListener(eventName, function () { onFieldCommitted(checks[checkIndex]); });
      }

      wireCommit(form.querySelector('#AS-name'), 'blur', 0);
      wireCommit(form.querySelector('#AS-phone'), 'blur', 1);
      wireCommit(form.querySelector('#AS-email'), 'blur', 2);

      Array.prototype.forEach.call(form.querySelectorAll('input[name="contact[La demande est pour]"]'), function (r) {
        wireCommit(r, 'change', 3);
      });

      wireCommit(form.querySelector('#AS-city'), 'change', 4);

      if (serviceGroup) {
        serviceGroup.addEventListener('change', function () { onFieldCommitted(checks[5]); });
      }

      Array.prototype.forEach.call(form.querySelectorAll('input[name="contact[Besoin]"]'), function (r) {
        wireCommit(r, 'change', 6);
      });

      Array.prototype.forEach.call(form.querySelectorAll('input[name="contact[Moment préféré]"]'), function (r) {
        wireCommit(r, 'change', 7);
      });

      wireCommit(form.querySelector('#AS-consent'), 'change', 8);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
